var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11196",
    "data-name": "Group 11196",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.242,
    height: 15.451,
    viewBox: "0 0 13.242 15.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4103",
    "data-name": "Rectangle 4103",
    width: 13.242,
    height: 15.451,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11195",
    "data-name": "Group 11195",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M1.1,3.862c-.167,0-.324,0-.482,0a.863.863,0,0,1-.237-.036.534.534,0,0,1-.376-.46A.5.5,0,0,1,.2,2.884a.666.666,0,0,1,.388-.122.752.752,0,0,1,.078,0H3.309V2.668q0-.5,0-.992A1.643,1.643,0,0,1,4.826.018C4.952.005,5.079,0,5.2,0,6.214,0,7.223,0,8.232,0a1.6,1.6,0,0,1,.932.257A1.641,1.641,0,0,1,9.907,1.4a2.248,2.248,0,0,1,.021.309c0,.316,0,.632,0,.949v.1h.108q1.289,0,2.578,0a.954.954,0,0,1,.221.027.525.525,0,0,1,.4.473.539.539,0,0,1-.349.549.939.939,0,0,1-.26.05c-.16.008-.321,0-.494,0v7.124c0,.937.011,1.874,0,2.811a1.637,1.637,0,0,1-.83,1.441,1.5,1.5,0,0,1-.647.194c-.154.015-.31.018-.465.018h-7.3a1.794,1.794,0,0,1-.813-.157,1.625,1.625,0,0,1-.957-1.365c-.013-.128-.016-.258-.016-.387Q1.1,8.769,1.1,4Zm1.1,0v.105q0,4.859,0,9.717c0,.029,0,.058,0,.086a.548.548,0,0,0,.361.528.994.994,0,0,0,.33.046q3.733,0,7.467,0c.037,0,.075,0,.112,0a.553.553,0,0,0,.533-.412.952.952,0,0,0,.028-.238q0-4.872,0-9.743V3.867ZM4.41,2.755H8.822a.213.213,0,0,0,.005-.03c0-.342,0-.684,0-1.026A.561.561,0,0,0,8.5,1.163a.755.755,0,0,0-.336-.06q-1.564,0-3.129,0A.792.792,0,0,0,4.8,1.14a.512.512,0,0,0-.368.406,1.269,1.269,0,0,0-.019.24c0,.293,0,.586,0,.879v.09",
    transform: "translate(0 -0.001)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M97.149,135.369c0,.8,0,1.6,0,2.4a.6.6,0,0,1-.175.461.531.531,0,0,1-.9-.325,2.434,2.434,0,0,1-.017-.308q0-2.319,0-4.637a.588.588,0,0,1,.208-.49.506.506,0,0,1,.526-.085.511.511,0,0,1,.339.43,2.238,2.238,0,0,1,.017.3q0,1.125,0,2.25",
    transform: "translate(-91.64 -126.264)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M169.148,135.379c0,.8,0,1.6,0,2.4a.591.591,0,0,1-.228.506.532.532,0,0,1-.844-.362,2.567,2.567,0,0,1-.017-.291q0-2.332,0-4.663a.589.589,0,0,1,.2-.484.533.533,0,0,1,.871.34,2.251,2.251,0,0,1,.017.3q0,1.129,0,2.258",
    transform: "translate(-160.328 -126.265)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.07ec099602d5088530bd4802ec6e9ee7.svg";
export { ForwardRef as ReactComponent };